interface FlussUserLike {
    isAdmin?: boolean;
    roles?: unknown[];
}

const roleSet = (user?: FlussUserLike | null) =>
    new Set((user?.roles || []).map(String));

const isPlatformAdministrator = (user: FlussUserLike | null | undefined, roles: Set<string>) =>
    user?.isAdmin === true || roles.has("platform_administrator");

export const canDesignFluss = (user?: FlussUserLike | null) => {
    const roles = roleSet(user);
    return isPlatformAdministrator(user, roles) ||
        roles.has("fluss_analyst") ||
        roles.has("fluss_developer");
};

export const canAutomateFluss = (user?: FlussUserLike | null) => {
    const roles = roleSet(user);
    return isPlatformAdministrator(user, roles) || roles.has("fluss_developer");
};

export const canAuthorFlussScript = (user?: FlussUserLike | null) => {
    const roles = roleSet(user);
    return isPlatformAdministrator(user, roles) || roles.has("fluss_script_author");
};

export const canViewFlussAdvanced = (user?: FlussUserLike | null) =>
    roleSet(user).has("fluss_developer");

export const canOperateFluss = (user?: FlussUserLike | null) => {
    const roles = roleSet(user);
    return isPlatformAdministrator(user, roles) ||
        roles.has("fluss_operator") ||
        roles.has("fluss_developer");
};

// AJUSTE 008: deleting a definition is destructive/irreversible, so it needs its own dedicated
// role on top of fluss_developer — mirrors FlussEngine::EnginePolicy::DELETE_ROLES on the backend.
export const canDeleteFlussDefinition = (user?: FlussUserLike | null) => {
    const roles = roleSet(user);
    return isPlatformAdministrator(user, roles) || roles.has("fluss_definition_delete");
};

// UI hint only; the backend policy is the source of truth for discard authorization.
export const canDiscardFlussDraft = canDeleteFlussDefinition;
